import { render, staticRenderFns } from "./OTPMerVN.vue?vue&type=template&id=e87ac246&scoped=true&"
import script from "./OTPMerVN.vue?vue&type=script&lang=js&"
export * from "./OTPMerVN.vue?vue&type=script&lang=js&"
import style0 from "./OTPMerVN.vue?vue&type=style&index=0&id=e87ac246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87ac246",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QCardSection}, component.options.components || {})
